import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { portfolioData } from '../mock';

const Portfolio = () => {
  const projectRoutes = {
    1: '/restaurant',
    3: '/kosmetikstudio',
    4: '/handwerker',
    5: '/immobilienmakler'
  };

  const extendedProjects = [
    ...portfolioData.projects,
    {
      id: 5,
      title: "Immobilienmakler-Website",
      description: "Professionelle Website für Immobilienmakler mit Objektpräsentation und Kontaktformular.",
      category: "Unternehmenswebsite",
      image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw1fHxyZWFsJTIwZXN0YXRlfGVufDB8fHx8MTczNzU3OTY5N3ww&ixlib=rb-4.1.0&q=85",
      technologies: ["React", "Node.js", "Maps API"]
    }
  ];

  return (
    <section id="portfolio" className="py-20 px-6 lg:px-8 bg-[#F1F5F9]">
      <div className="max-w-6xl mx-auto">
        <div className="mb-20">
          <h2 className="text-5xl sm:text-6xl font-bold text-black mb-6">
            Projekte
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl">
            Ausgewählte Arbeiten
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {extendedProjects.map((project) => {
            const route = projectRoutes[project.id];
            const isInternal = route !== null && route !== undefined;

            const CardWrapper = isInternal ? Link : 'div';
            const cardProps = isInternal ? { to: route } : {};

            return (
              <CardWrapper key={project.id} {...cardProps}>
                <div className="group cursor-pointer">
                  <div className="relative overflow-hidden aspect-video mb-6 bg-[#E2E8F0] rounded-lg">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <h3 className="text-2xl font-bold text-black mb-2 group-hover:text-[#1E40AF] transition-colors">
                        {project.title}
                      </h3>
                      <p className="text-gray-600 mb-4">
                        {project.description}
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {project.technologies.map((tech, index) => (
                          <span
                            key={index}
                            className="px-3 py-1 bg-[#E2E8F0] text-[#1E3A8A] text-sm font-medium rounded"
                          >
                            {tech}
                          </span>
                        ))}
                      </div>
                    </div>
                    {isInternal && (
                      <ArrowUpRight className="text-[#1E40AF] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" size={24} />
                    )}
                  </div>
                </div>
              </CardWrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;